import { useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';

import {
  addOrModifyMetadataInput,
  addRunningProcess,
  removeRunningProcess,
} from 'apps/web_forms/slices/formSlice';
import { getCurrentPosition } from 'apps/web_forms/utils/locationHelpers';
import { getFormattedDate } from 'apps/web_forms/utils/dateTimeFormatter';

const useInputMetadata = ({ element }) => {
  const dispatch = useDispatch();
  const { timestamp, geostamp, identifier } = element;

  const updateInputMetadata = useCallback(
    async (callback) => {
      if (!timestamp && !geostamp) return;

      const processName = `${element.identifier} metadata`;
      dispatch(addRunningProcess(processName));

      let metadata = {};
      if (timestamp) metadata.timestamp = getFormattedDate();

      try {
        dispatch(
          addOrModifyMetadataInput({
            key: identifier,
            value: metadata,
          })
        );
        callback();

        if (geostamp) {
          const { latitude, longitude, accuracy } = await getCurrentPosition();

          dispatch(
            addOrModifyMetadataInput({
              key: identifier,
              value: {
                ...metadata,
                geostamp: `lat=${latitude}, long=${longitude}, accuracy=${accuracy}`,
              },
            })
          );
          callback();
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('Location error: ', err);
      } finally {
        dispatch(removeRunningProcess(processName));
      }
    },
    [timestamp]
  );

  return { updateInputMetadata };
};

export default useInputMetadata;
